import axios from 'axios'

export default {
  getAudio() {
    return axios({
      method: 'post',
      url: (process.env.NODE_ENV === 'development' ? 'http://localhost:8081' : '') + '/api/audio',
      data: {
        
      }
    })
  }
}